import type { LoqateErrorResponse } from "./types";

export function isLoqateErrorResponse(
  response: unknown,
): response is LoqateErrorResponse {
  return Array.isArray(response) && response.some(item => "Error" in item);
}
